import Joi from "joi";
import errorsResolver from "../schemeUtils";

const LAST_NAME_LENGTH = 100;
const FIRST_NAME_LENGTH = 100;
const MIDDLE_NAME_LENGTH = 100;

const clientNamesScheme = Joi.object({
    index: Joi.any(),
    lastName: Joi.string()
        .trim()
        .max(LAST_NAME_LENGTH)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]{1,100}$'))
        .error(errorsResolver({
            max: `Фамилия должна быть до ${LAST_NAME_LENGTH} символов`,
            required: `Фамилия обязательное поле`,
            pattern: `Фамилия содержит некорректные символы`
        })),
    firstName: Joi.string()
        .trim()
        .max(FIRST_NAME_LENGTH)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]{1,100}$'))
        .error(errorsResolver({
            max: `Собственное имя должно быть до ${LAST_NAME_LENGTH} символов`,
            required: `Собственное имя обязательное поле`,
            pattern: `Собственное имя содержит некорректные символы`
        })),
    middleName: Joi.string()
        .trim()
        .max(MIDDLE_NAME_LENGTH)
        .allow('')
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\- ]{1,100}$'))
        .error(errorsResolver({
            max: `Отчество должно быть до ${MIDDLE_NAME_LENGTH} символов`,
            required: `Отчество обязательное поле`,
            pattern: `Отчество содержит некорректные символы`
        }))
});


export default clientNamesScheme;
